export const COL_SPAN_TWO = 2
export const COL_SPAN_THREE = 3
export const MOBILE_LARGE_VIEW_WIDTH = 580
